import { render, staticRenderFns } from "./chat-title.vue?vue&type=template&id=2abb4fd4&scoped=true"
import script from "./chat-title.vue?vue&type=script&lang=js"
export * from "./chat-title.vue?vue&type=script&lang=js"
import style0 from "./chat-title.vue?vue&type=style&index=0&id=2abb4fd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb4fd4",
  null
  
)

export default component.exports